import { llmZh } from './llm/index.js'
import { ugcZh } from './ugc.js'

export const zh = {
  visualGameAdmin: {
    pageFunnel: {'button': '查看页面漏斗', 'title': '页面漏斗', 'home': '首页', 'auth': '登录/注册入口', 'game': '游玩页面', 'note': '按所选时间和设备统计同一访问会话中依次访问各步骤的数量。登录入口包含登录页面和 PC 登录/注册弹窗打开；已登录用户直接游玩不经过登录这一级；未埋点的历史弹窗打开无法补算。', 'loading': '加载中…', 'error': '加载失败', 'sessions': '访问会话'},
    conversionFunnelDevices: { label: '来源设备类型', all: '全部', desktop: '电脑', mobile: '手机', tablet: '平板' },
    app: {
      name: 'Visual Game Admin',
      waitlist: '候补名单',
      invitationCodes: '邀请码',
      users: 'C 端用户',
      analytics: '总览',
      contentAnalytics: '内容互动',
      ga4Behavior: '用户行为',
      conversionFunnel: '转化漏斗',
      generationRecords: '生成记录',
      ugcReview: 'UGC 审核',
      tagManagement: '标签管理',
      gameReleases: '游戏发布',
      homepageCarousel: '首页轮播管理',
      homepagePopularPins: '首页热门置顶',
      assetLibrary: '资产库',
      promptLibrary: '提示词库',
      entityLibrary: '实体库',
      modelCapabilities: '模型能力',
      h3Config: 'H3 视频参数',
      llm: '厂商',
      llmModes: '场景路由',
      llmRuntime: 'API Key 状态',
      llmRecon: '对账',
      llmCost: '成本',
      llmCalls: '调用日志',
      llmConversations: 'Agent 对话',
      llmTurnTimelines: '回合时间线',
      groups: {
        growth: '用户与增长',
        billing: '商业化',
        analytics: '数据报表',
        content: '内容与资产',
        intentVideos: '意图视频',
        modelConfig: '模型配置',
        modelObservability: '调用观测',
        modelFinance: '成本与账务',
      },
      logout: '退出',
      theme: { toLight: '切到亮色', toDark: '切到暗色' },
      forbidden: '当前账号不能访问 visual-game 运营后台。',
    },
    llm: llmZh,
    ugc: ugcZh,
    homepageCarousel: {
      title: '首页轮播管理', subtitle: '配置玩家首页顶部轮播的内容、状态和展示顺序。', add: '新增轮播项', empty: '暂无轮播项', emptyDescription: '新增 YouTube 视频或剧情内容后会显示在玩家首页。', order: '顺序', type: '类型', content: '内容', status: '状态', enabled: '已启用', disabled: '已停用', enable: '启用', disable: '停用', saved: '轮播项已保存', deleted: '轮播项已删除', deleteConfirm: '确定删除这个轮播项吗？', createTitle: '新增轮播项', editTitle: '编辑轮播项', referenceId: 'YouTube 视频 ID', youtubeHint: '填写 YouTube 视频链接中 v= 后面的编号。', story: '选择剧情', storyHint: '同一系列的多集剧情会合并为一个轮播选项。', storyPlaceholder: '请选择剧情', storySearchPlaceholder: '搜索剧情名称、系列或编号', storySearchEmpty: '没有匹配的剧情', eyebrow: '眉题', itemTitle: '标题覆盖', summary: '摘要覆盖', types: { youtube: 'YouTube', story: '剧情' }, defaultStoryTitles: { otomeCastle: '编织于时空中的梦恋' },
    },
    homepagePopularPins: {
      title: '首页热门置顶', subtitle: '配置玩家首页热门区的人工置顶顺序，未置顶内容仍按真实游玩次数排序。', add: '添加置顶', empty: '暂无置顶剧情', emptyDescription: '不配置时，热门区完全按真实游玩次数排序。', order: '顺序', story: '剧情', status: '状态', enabled: '已启用', disabled: '已停用', enable: '启用', disable: '停用', saved: '热门置顶已保存', deleted: '热门置顶已删除', deleteConfirm: '确定将这个剧情移出热门置顶吗？', createTitle: '添加热门置顶', storyHint: '同一系列的多集剧情会合并为一个选项。', storyPlaceholder: '请选择剧情', storySearchPlaceholder: '搜索剧情名称、系列或编号', storySearchEmpty: '没有可添加的剧情', moveUp: '上移剧情', moveDown: '下移剧情',
    },
    auth: {
      title: '运营登录',
      subtitle: '管理 visual-game 早期访问申请。',
      email: '邮箱',
      password: '密码',
      login: '登录',
      loggingIn: '登录中',
      failed: '登录失败，请检查账号和密码。',
    },
    scenarioPicker: {
      title: '选择游戏',
      searchPlaceholder: '搜索游戏名称、系列或编号',
      emptyResult: '没有匹配的游戏',
    },
    gameReleases: {
      title: '发布游戏',
      subtitle: '把 Stage 当前已发布版本推送到正式环境，并立即切换生效。',
      selectLabel: '发布来源',
      selectTitle: '选择 Stage 游戏',
      selectHint: '这里复用资产库的游戏选择器，游戏名称、封面、系列和编号保持一致。',
      emptyTitle: '先选择一个游戏',
      emptyDescription: '每次只会更新当前选中的游戏剧本。',
      stage: 'Stage 环境',
      production: '正式环境',
      source: '来源环境',
      target: '目标环境',
      published: '已发布',
      version: '版本',
      versionId: '版本编号',
      publishedAt: '发布时间',
      assets: '版本资源',
      syncAssets: '去重同步对象',
      contentGraph: '实体 / 绑定 / Prompt',
      videoResources: '视频资源库',
      intentVideos: '其中意图视频 {count}',
      translations: '翻译内容',
      checks: '发布检查',
      connection: { reachable: '连接正常', not_configured: '尚未配置', unreachable: '连接失败' },
      connectionHelp: {
        not_configured: '请在 Stage 配置 SCENARIO_RELEASE_TARGET_URL 和 SCENARIO_RELEASE_TOKEN。',
        unreachable: '请检查正式环境 API 和共享发布凭据。',
      },
      readyTitle: '已具备发布条件',
      resyncTitle: '正式环境已是当前版本',
      scope: '同步当前剧本版本、翻译、实体资源图、视频资源库（含意图视频和向量）及去重媒体对象；不会修改正式环境用户、游玩记录、点赞或计数。',
      adminRequired: '运营账号可以查看版本，发布操作需要管理员账号。',
      publish: '发布到正式环境',
      resync: '重新同步资源',
      successTitle: '正式版本已生效',
      successSummary: 'v{version} 已切换 · 新上传 {copied} 个 · 复用 {reused} 个 · 传输 {size}',
      confirmTitle: '确认发布到正式环境',
      confirmScope: '将核对 {assets} 个去重资源对象；正式存储已存在且 hash 一致的对象直接复用，仅下载并上传缺失对象，完成后再切换版本。',
      noUserData: '不会复制用户、游玩进度、对局、点赞或运营计数。',
      confirmPublish: '确认并发布',
      historyTitle: '发布记录与日志',
      historyHint: '记录每次发布锁定的版本、操作人、资源传输结果和完整状态变化。',
      historyEmpty: '这个游戏还没有发布到正式环境的记录。',
      operator: '操作人',
      startedAt: '开始时间',
      transfer: '上传 / 复用 / 流量',
      releaseStatus: {
        prepared: '已准备',
        transferring: '传输中',
        applying: '生效中',
        succeeded: '已成功',
        failed: '已失败',
      },
    },
    tagManagement: {
      subtitle: '共 {count} 个剧本 · 包含公开、私有与不公开',
      placeholder: '剧情, 悬疑, 奇幻',
      searchLabel: '搜索标签',
      searchPlaceholder: '搜索标签或关联游戏',
      stats: { tags: '标签数', packs: '游戏数', untagged: '未标记游戏' },
      table: { tag: '标签', usage: '使用次数', packs: '关联游戏' },
      usageCount: '{count} 个游戏',
      viewPacks: '查看游戏',
      detailLabel: '标签详情',
      editPack: '编辑标签',
      editTitle: '编辑「{title}」的标签',
      tagsLabel: '游戏标签',
      tagsHint: '用英文逗号分隔，最多 12 个。',
      emptyTitle: '没有匹配的标签',
      emptyDescription: '请尝试其他关键词，或先为游戏添加标签。',
      tooManyTags: '每个游戏最多可以设置 12 个标签。',
      saved: '标签已更新。',
    },
    common: {
      actions: '操作',
      cancel: '取消',
      confirm: '确认',
      retry: '重试',
      refresh: '刷新',
      reset: '重置',
      loading: '加载中',
      empty: '当前筛选没有候补者。',
      error: '请求失败。',
      export: '导出',
      view: '查看',
      invite: '邀请',
      resend: '重发',
      reject: '拒绝',
      note: '备注',
      create: '创建',
      close: '关闭',
      save: '保存',
      edit: '编辑',
      delete: '删除',
      working: '处理中…',
      back: '返回',
    },
    billing: {
      readOnly: '只读：只有 admin 能修改',
      saved: '已保存。',
      turnsCovered: '≈ {n} 回合',
      actionRefund: '{name}失败退还',
      ledgerReasons: {
        signup_gift: '注册赠送', purchase: '积分购买', purchase_paid: '积分购买', purchase_bonus: '购买赠送',
        daily_claim: '每日领取', admin_adjustment: '人工调整', manual_admin_grant: '人工赠送', platform_seed: '初始积分',
        model_usage: '按调用计费', llm: '模型调用（旧）', visual_game_tts: '语音合成（旧）',
        payment_refund_reversal: '订单退款扣回', payment_dispute_reversal: '拒付扣回',
        unlock_episode: '解锁剧集', unlock_branch: '解锁分支', unlock_continue: '解锁续玩', unlock_ending: '解锁结局',
      },
      ledgerSources: {
        admin: '后台操作', legacy_admin: '后台操作（旧）', daily_reward: '每日领取', visual_game_signup: '注册',
        platform: '平台', stripe: 'Stripe 支付', system: '系统', gameplay: '游戏', unlock: '内容解锁',
        llm: '模型调用', tts: '语音合成', image_generation: '图片生成', video_generation: '视频生成',
      },
      ledgerRefTypes: {
        admin_action: '后台操作', daily_claim: '每日领取', order: '订单', run_turn: '回合', run_video: '整局视频',
        intent_video_request: '回合视频任务', unlock: '内容解锁', source: '来源',
        llm_chat: '模型对话', llm_operation: '模型调用', tts_operation: '语音合成', visual_game_tts: '语音合成（旧）',
        image_operation: '图片生成', video_operation: '视频生成',
      },
      modelUsageKinds: { llm: 'LLM', tts: '语音', image: '图片', video: '视频' },
      actionNames: { daily_claim: '每日领取', turn_play: '有效回合', full_run_video: '整局视频', intent_video_on_demand: '回合视频', signup_reward: '注册赠送' },
      actionHints: {
        daily_claim: '登录用户每天可以在充值界面主动领取一次的积分。',
        turn_play: '每提交一个有效回合预扣的积分；生成失败自动退还。',
        full_run_video: '用户确认生成整局视频时，每次扣除的积分。',
        intent_video_on_demand: '用户确认生成单个回合视频时，每次扣除的积分；生成失败自动退还。',
        signup_reward: '新账号注册成功时自动赠送的积分。',
      },
      periods: { daily: '每天一次', none: '每次动作' },
      enabledState: { on: '启用', off: '停用' },
      pager: { prev: '上一页', next: '下一页', pageSize: '每页条数', summary: '第 {page} 页 · 本页 {n} 条' },
      dashboard: {
        nav: '总览',
        title: '商业化看板',
        windowDays: '{n} 天',
        drill: '点击可下钻',
        range: { label: '时间范围', days: '最近 {n} 天', custom: '自定义', since: '起始日期', until: '结束日期' },
        sections: { revenue: '收入', points: '积分', conversion: '转化', risk: '风控', products: '商品销量', spendMix: '消耗结构' },
        charts: { revenue: '收入', paidOrders: '付费订单', refundOrders: '退款与拒付', pointsGranted: '积分发放', pointsSpent: '积分消耗' },
        revenue: { gross: '总收入', refund: '退款金额', net: '净收入', paidOrders: '付费订单', payingUsers: '付费用户', firstTimeBuyers: '首充用户' },
        points: {
          purchasedPaid: '购买实付', purchasedBonus: '购买赠送', dailyClaim: '每日领取', signupReward: '注册赠送', adminGrant: '后台赠送',
          actionSpent: '{name}消耗', otherSpent: '其他消耗', actionRefunded: '{name}退还',
        },
        conversion: {
          newUsers: '新注册', newUsersPaid: '注册后付费', signupToPaidRate: '注册转充值率', activeUsers: '活跃用户', claimUsers: '领取用户', claimRate: '每日领取率',
          note: '注册转充值率：窗口内注册且有过付费的用户 ÷ 窗口内注册用户。每日领取率：领取过每日积分的用户 ÷ 窗口内有任何积分流水的用户。',
        },
        risk: {
          refundedOrders: '退款订单', refundRate: '退款率', disputedOrders: '拒付订单', disputeRate: '拒付率',
          actionRefunds: '{name}失败退款', shortfallOrders: '差额订单', shortfallPoints: '差额积分',
          note: '退款率、拒付率 = 窗口内发生的冲正 ÷ 窗口内支付的订单。差额：冲正时余额已被花掉、扣不回的积分。',
        },
        emptyProducts: '这段时间没有付费订单。',
        emptySpend: '这段时间没有积分消耗。',
      },
      policies: {
        title: '收费规则',
        description: '每个动作扣多少积分、送多少积分。保存后立即对所有用户生效。',
        table: { action: '动作', points: '积分', period: '频率', timezone: '时区', enabled: '状态' },
        form: {
          title: '编辑规则 · {action}',
          points: '积分',
          timezone: '时区',
          timezoneHint: 'IANA 时区名，如 America/Los_Angeles；每日领取按这个时区的自然日重置。',
          enabled: '状态',
          enabledHint: '停用后不再扣费或赠送，配置保留。',
        },
        errors: { points: '积分必须是不小于 1 的整数。', timezone: '每日类动作必须填写时区。' },
      },
      products: {
        title: '积分商品',
        description: '通过 Stripe Checkout 出售的积分包。到账积分含赠送；折合回合按当前有效回合价格估算。',
        table: { title: '商品', id: '编号', paidPoints: '实付积分', bonusPoints: '赠送积分', totalPoints: '到账积分', turns: '折合回合', price: '售价', stripePrice: 'Stripe 价格', active: '状态' },
        activeState: { on: '在售', off: '已下架' },
        form: {
          title: '编辑商品 · {name}',
          name: '商品名称',
          paidPoints: '实付积分',
          bonusPoints: '赠送积分',
          price: '售价（美元）',
          priceHint: '最多两位小数，如 9.99。',
          stripePrice: 'Stripe 价格 ID',
          stripePriceHint: 'Stripe 里建好价格前留空；没有它用户无法发起支付。',
          active: '状态',
          totalPoints: '到账积分',
          turns: '折合回合',
        },
        errors: {
          name: '商品名称不能为空。',
          paidPoints: '实付积分必须是不小于 1 的整数。',
          bonusPoints: '赠送积分必须是不小于 0 的整数。',
          price: '售价必须是正数，最多两位小数。',
        },
      },
      orders: {
        title: '支付订单',
        filters: { orderId: '订单编号', userId: '用户编号', product: '商品', allProducts: '全部商品', status: '状态', allStatuses: '全部状态', scope: '冲正', scopeAll: '全部订单', scopeShortfall: '仅看有差额', since: '创建起始', until: '创建截止' },
        table: { time: '创建时间', id: '订单编号', user: '用户', product: '商品', status: '状态', amount: '金额', points: '到账积分', reversed: '已冲正', shortfall: '差额' },
        status: { pending: '待支付', paid: '已支付', canceled: '已取消', failed: '失败', refunded: '已退款', disputed: '争议中' },
        empty: '没有符合条件的订单。',
      },
      ledger: {
        title: '积分流水',
        filters: { userId: '用户编号', reason: '原因', source: '来源', refType: '业务类型', allReasons: '全部原因', allSources: '全部来源', allRefTypes: '全部类型', refId: '业务编号', since: '起始时间', until: '结束时间' },
        table: { time: '时间', user: '用户', type: '类型', amount: '变动', balance: '变动后余额', reason: '原因', source: '来源', reference: '业务对象', note: '备注' },
        type: { grant: '增加', deduct: '扣减' },
        empty: '没有符合条件的流水。',
      },
    },
    invitationCodes: {
      title: '邀请码列表',
      createTitle: '手动创建邀请码',
      email: '玩家邮箱',
      emailOptional: '选填，留空则不绑定邮箱',
      count: '生成数量',
      batchUnboundHint: '批量生成的邀请码不绑定邮箱，单次最多生成 100 个。',
      generate: '生成邀请码',
      created: '已生成 {count} 个邀请码',
      createFailed: '邀请码操作失败',
      resent: '已重新生成邀请码',
      copied: '已复制',
      copyCode: '复制邀请码',
      copyLink: '复制链接',
      regenerateRequired: '需重新生成',
      listTitle: '邀请记录',
      selectAll: '全选',
      selectCode: '选择邀请码 {code}',
      batchCopy: '批量复制邀请码（{count}）',
      batchCopied: '已复制 {count} 个邀请码',
      refresh: '刷新',
      empty: '还没有手动创建的邀请码。',
      regenerate: '重新生成',
      table: {
        select: '选择',
        email: '玩家邮箱',
        code: '邀请码',
        status: '注册状态',
        inviteState: '邀请状态',
        expiresAt: '过期时间',
        createdAt: '创建时间',
      },
    },
    generationRecords: {
      title: '生成记录',
      actions: {
        refresh: '刷新',
        editCopy: '编辑文案',
        backToGroups: '返回分组',
        viewProcess: '完整流程',
      },
      filters: {
        q: '搜索',
        qPlaceholder: 'Run、剧本、结局或记录 ID',
        status: '状态',
        allStatuses: '全部状态',
        scenario: '剧本',
        allScenarios: '全部剧本',
        search: '搜索',
      },
      stats: {
        total: '总数',
        plays: '总播放',
      },
      sections: {
        videos: '完整视频',
      },
      status: {
        queued: '排队中',
        running: '生成中',
        ready: '已完成',
        failed: '失败',
      },
      variant: {
        endingVideo: '结局视频',
        gameplayReplay: '完整回放',
        gameplayTurn: '单回合回放',
      },
      pipelineStep: {
        run: '对局完成',
        requested: '请求出片',
        screenplay: '改编分镜',
        production: '视频生产',
      },
      pipeline: {
        ready: '已完成',
        failedScreenplay: '改编失败',
        failedProduction: '视频生成失败',
        producing: '视频生成中',
        awaitingScreenplay: '等待改编',
      },
      metrics: {
        plays: '播放 {count}',
        likesAndFavorites: '赞 {likes} · 收藏 {favorites}',
      },
      group: {
        count: '{count} 个视频',
      },
      process: {
        title: '完整流程',
        back: '返回',
        videoId: '视频记录 ID',
        runId: 'Run ID',
        empty: '暂无数据',
        stages: {
          run: '对局完成',
          requested: '请求出片',
          screenplay: '改编分镜',
          production: '分镜生产',
          assembly: '拼接成片',
        },
        stageNote: {
          turns: '{count} 回合',
          scenes: '{count} 场',
          segments: '{done} / {total} 场已入库',
        },
        facts: {
          status: '状态',
          ending: '结局',
          player: '角色',
          version: '剧本版本',
          provider: '生产方式',
          generationRequest: '生成请求',
          author: '改编者',
        },
        transcript: {
          title: '对局回放',
          opening: '开场',
          player: '玩家',
          npc: 'NPC',
          toScene: '→ 场次 {scene}',
          ending: '结局',
        },
        scene: {
          title: '分镜与生产',
          scene: '场次 {scene}',
          turn: '第 {turn} 回合',
          anchor: '起链',
          extend: '续接',
          chainFrom: '续接场次 {scene} 的尾帧',
          source: '来源回合',
          screenplay: '分镜',
          production: '生成',
          frames: '{count} 帧',
          prompt: '提示词',
          callPrompt: '本次提交的提示词',
          promptChars: '{count} 字',
          firstFrame: '首帧',
          endFrame: '尾帧',
          calls: '调用记录',
          noCalls: '尚未提交调用',
          points: '{count} 点',
          stage: {
            pending: '未开始',
            submitted: '生成中',
            ok: '调用完成',
            error: '生成失败',
            stored: '已入库',
          },
          call: {
            submitted: '进行中',
            ok: '成功',
            error: '失败',
          },
        },
        assembly: {
          title: '成片拼接',
          opening: '开场 CG',
          ending: '结局 CG',
          segments: '{count} 段',
          open: '打开成片',
        },
      },
      pagination: {
        prev: '上一页',
        next: '下一页',
        pageSize: '每页',
        summary: '共 {total} 条 · 第 {page} / {pages} 页',
      },
      preview: {
        title: '视频预览',
      },
      edit: {
        title: '编辑视频标题和简介',
        videoTitle: '视频标题',
        videoSummary: '视频简介',
        saved: '视频标题和简介已更新',
      },
      empty: {
        videos: {
          title: '没有视频记录',
          description: '当前筛选下没有完整视频生成记录。',
        },
        groups: {
          title: '没有匹配的分组',
          description: '当前筛选下没有生成记录。',
        },
      },
    },
    intentVideo: {
      title: '意图视频',
      subtitle: '按玩家意图语义召回的兜底视频库。未命中的意图进队列，离线出片后自动进召回池。',
      tabs: { preparation: '准备状态', clusters: '意图聚类', queue: '生成队列', resources: '资源列表', recall: '向量召回测试', logs: '任务日志', h3Queue: 'H3 排队' },
      h3Queue: {
        subtitle: 'H3 只有一个后端、任务严格串行；结局视频和意图视频按需生成两条付费路径靠这张表抢插队资格。',
        currentHolder: '当前插队资格',
        noHolder: '当前没有付费任务持有插队资格。',
        backend: 'H3 真实排队深度',
        recent: '最近记录',
        jobSource: '来源',
        jobRefId: '任务引用',
        createdAt: '创建时间',
        updatedAt: '更新时间',
        status: '状态',
        queued: '排队中',
        running: '执行中',
        ready: '可用后端',
        source: { run_video: '结局视频', intent_video_on_demand: '意图视频按需生成' },
      },
      preparation: {
        subtitle: '统一查看全部游戏的动作意图视频、玩家说话视频和 NPC 说话视频准备进度。',
        scenario: '游戏',
        action: '动作意图视频',
        player: '玩家无声视频',
        npc: 'NPC 无声视频',
        clusterStatus: {
          ready: '分析已更新',
          stale: '需要重新分析',
          not_analyzed: '尚未分析',
          no_history: '暂无动作样本',
        },
        actionCounts: '{turns} 回合 · {clusters} 个聚类 · 目标 {target} 条 · 可播 {videos} 条',
        coverage: '历史召回覆盖率 {rate}%',
        talkingCounts: '{entities} 个角色 · 规格 {specs} · 审核 {approved_specs}/{specs} · 基准图 {state_frames} · 成片 {videos}',
        notConfigured: '尚未配置',
        inProgress: '准备中',
        ready: '已就绪',
      },
      status: { in_review: '待审核', published: '已发布', rejected: '已禁用' },
      queueStatus: {
        pending: '待写提示词',
        prompting: '写提示词中',
        prompt_ready: '待出片',
        rendering: '出片中',
        done: '已完成',
        failed: '失败',
      },
      source: { cluster: '聚类', gameplay: '游玩', admin: '后台手动' },
      stats: {
        total: '资源总数',
        withVideo: '有片',
        promptOnly: '只有提示词',
        disabled: '已禁用',
        coverage: '历史覆盖率',
        coverageNote: '{covered}/{total} 个历史回合有片能召回（{inputs}/{uniqueInputs} 句意图）。这个数是实时查库的。',
      },
      filters: {
        search: '搜索',
        apply: '筛选',
        allStatuses: '全部状态',
        allSources: '全部来源',
        allVideo: '全部',
        withVideo: '有片',
        promptOnly: '只有提示词',
        sort: '排序',
        order: '方向',
        desc: '降序',
        asc: '升序',
        queueSearchPlaceholder: '意图文本',
        resourceSearchPlaceholder: '意图文本或资源 ID',
      },
      table: {
        status: '状态',
        intent: '意图文本',
        occurrences: '出现次数',
        source: '来源',
        attempt: '重试',
        lastError: '失败原因',
        updatedAt: '更新时间',
        createdAt: '创建时间',
        video: '视频',
        duration: '时长',
        resolution: '分辨率',
        hits: '命中次数',
        similarity: '相似度',
      },
      pager: {
        prev: '上一页',
        next: '下一页',
        pageSize: '每页条数',
        loadedAll: '共 {n} 条',
        loadedMore: '本页 {n} 条，还有更多',
      },
      queue: {
        retried: '已重回队列',
        autoGenerate: '自动生成',
        autoGenerated: '已开始自动生成，稍后在这里查看进度',
        rePrompt: '重写提示词',
        rePromptHint: '解绑现有资源、回到队首，下一轮按当前的参考图和规范重写。想直接拿现成的提示词再拍一遍，用详情里的「重新出片」。',
        rePrompted: '已回到队首，等按新规范重写',
        emptyTitle: '队列是空的',
        emptyDescription: '跑 cli.mjs seed 灌入聚类意图，或等玩家打到没片的意图自动入队。',
      },
      resources: {
        emptyTitle: '没有匹配的资源',
        emptyDescription: '可以清空或调整当前筛选条件。',
      },
      taskLogs: {
        emptyTitle: '队列是空的',
        emptyDescription: '跑 cli.mjs seed 灌入聚类意图，或等玩家打到没片的意图自动入队。',
        pickTask: '在左边选一条任务',
        noLogs: '这条任务还没有调用记录',
        noLogsDescription: '还没走过「自动生成」或「重新出片」，或者是在补落库之前跑的老请求。',
        pickLog: '在中间选一条日志',
        logCount: '{n} 条日志',
        counts: '{logs} 条日志 · {turns} 个来源回合',
        type: {
          lemonboss: '拼提示词',
          embedding: '意图 embedding',
          h3: 'H3 出片',
        },
        status: {
          pending: '进行中',
          submitting: '进行中',
          submitted: '进行中',
          ok: '成功',
          error: '失败',
        },
        request: '请求',
        response: '响应',
        extra: '其它',
        id: 'ID',
        providerTaskId: '供应商任务 ID',
        pollCount: '轮询次数',
        fullPrompt: '完整提示词（task + 附件拼接）',
        contextFiles: '附带的上下文文件',
        contextFileNoSnapshot: '老记录，没存全文快照',
      },
      taskSources: {
        title: '来源回合（{n}）',
        open: '查看来源回合',
        search: '搜索玩家输入、回合 ID 或游戏局 ID',
        apply: '查询',
        newest: '最新在前',
        oldest: '最早在前',
        empty: '没有关联的来源回合',
        turn: '第 {n} 回合',
        playerInput: '玩家原始输入',
        noConversation: '这个回合没有 Agent 对话',
        openConversation: '查看 {role} 对话',
        page: '第 {page}/{pages} 页',
      },
      recall: {
        placeholder: '输入玩家意图，测试召回效果……',
        run: '召回',
        running: '正在 embedding + 向量检索……',
        hint: '走的是玩家链路同一条路：文本 → embedding → 向量检索 → 按相似度排序。相似度低于 0.75 的不会被播出。',
        query: '查询',
        hits: '命中 {n} 条',
        emptyTitle: '输入玩家意图文本',
        emptyDescription: '模拟真实召回流程，看这句话会命中哪几条片子、相似度多少。',
        noHitTitle: '没有召回结果',
        noHitDescription: '库里没有任何意图视频与这段文本相似。',
      },
      spec: {
        title: '出片规格',
        titleHint: '改的是「下一次按什么拍」，不影响现在这条片子的记录',
        empty: '这条还没写提示词。',
        write: '写提示词',
        references: '参考图',
        referencesHint: '顺序就是 <Picture N> 的编号：提示词里写 <Picture 2>，指的就是下面第二张。',
        param: {
          resolution: '分辨率',
          width: '宽',
          height: '高',
          frames: '时长',
          steps: '步数',
          seed: '随机种子',
          ref_image_short_edge: '参考图短边（选填）',
          turbo: 'Turbo',
        },
        turboOn: '开（4 步蒸馏）',
        turboOff: '关（完整采样）',
        protocolRules: '协议规则：turbo 开着时 steps 必须 ≤ 8；帧数按 17n+5 取整（24fps）。违反了 H3 直接拒收。',
        rationale: '选档理由',
        rationaleHint: '为什么值这个档位。后台看一条贵片子时，这句话就是它的辩护词。',
        measuredCost: '实测档位',
        edit: '编辑规格',
        save: '保存规格',
        saved: '规格已保存。要让它生效，点「重新出片」。',
        render: '重新出片',
        renderHint: '按上面这份规格调 H3 重拍一条。实测 152~657 秒，页面会自己刷状态。',
        renderStarted: '已提交 H3，出片中',
        renderingNote: '正在出片，状态每 5 秒自动刷新。可以关掉这个窗口，出完了回来看。',
        renders: '出片记录',
        renderedBy: '由 {by} 触发',
        manualNote: '这条资源被手工换过 {n} 次片，最近一次 {at}。当前播的是上传的那条，不是出片记录里的最后一条。',
      },
      detail: {
        title: '意图视频详情',
        back: '返回',
        occurrenceMeta: '{n} 次 · 来源 {source} · 第 {attempt} 次尝试',
        hitMeta: '已被播出 {n} 次',
        previewTask: '预览任务书',
        previewTaskHint: '这条请求现在触发生成会用到的参考图，AI 会从这些里挑几张、决定顺序——不代表最终一定全部用上。',
        previewTaskRaw: '查看发给 Lemonboss 的完整任务书原文',
        match: '意图匹配',
        intent: '意图文本',
        intentHint: '保存后会重算 embedding 并同步向量索引，立即影响后续召回。',
        intentSaved: '意图文本已更新，向量索引已同步',
        editIntent: '编辑意图',
        rejectionReason: '禁用原因',
        input: '输入',
        output: '输出',
        vector: '2048 维向量',
        prompt: 'H3 视频扩写 Prompt',
        origin: '出处',
        videoUrl: '视频地址',
        noVideo: '还没有出片',
        hasAudio: '有音轨',
        noAudio: '无音轨',
        disable: '禁用',
        enable: '恢复',
        disabled: '已从召回池移除',
        enabled: '已放回召回池',
        confirmDisable: '禁用后这条片子立即从召回池移除，玩家不会再看到它。文件保留，可随时恢复。',
        replace: '上传替换',
        replacePick: '选择 mp4',
        replaceHint: '首尾帧由服务端从这条视频现抽，不用另外传图。只接受 mp4，最大 25MB。',
        replaceFile: '待上传',
        replaceNote: '换片原因（选填）',
        replaceNotePlaceholder: '为什么换掉上一条',
        replaceSubmit: '上传并替换',
        replaced: '已换片，向量索引已同步',
        replaceWrongType: '只接受 mp4，选中的是 {mime}',
        replaceTooLarge: '文件 {size} 超过 25MB 上限',
      },
      clusters: {
        totalTurns: '历史回合',
        uniqueInputs: '唯一输入',
        totalClusters: '意图聚类',
        needFor70: '70% 需要',
        covered: '已覆盖',
        queued: '已入队',
        variants: '写法',
        variantCount: '{n} 种',
        productionColumn: '生成',
        productionAll: '全部生成状态',
        production: {
          none: '未排队',
          active: '排队中',
          done: '已出片',
          failed: '失败',
        },
        queueUnmatched: '队列里另有 {n} 条对不上任何聚类代表意图（多半是历史原话的写法变体），不在下表里。去「生成队列」看。',
        staleWithLastSuccess: '数据可能已过期：定时聚类分析连续失败 {n} 次，上次成功是 {at}。',
        staleNeverSucceeded: '数据可能已过期：定时聚类分析连续失败 {n} 次，从未成功过。',
        coverageColumn: '召回覆盖',
        coverageAll: '全部覆盖状态',
        coverage: {
          covered: '已覆盖',
          uncovered: '未覆盖',
        },
        coverageTarget: '覆盖率目标',
        coverageOff: '不限名次',
        coverageNeeds: '{percent}% → 前 {rank} 名（实到 {rate}%）',
        minOccurrences: '出现次数下限',
        minOccurrencesOff: '不限次数',
        minOccurrencesValue: '≥ {n} 次',
        searchPlaceholder: '搜索代表意图或写法变体',
        pageSummary: '共 {n} 个聚类 · 第 {page} / {pages} 页',
        note: '覆盖状态实时反映当前召回池：玩家打到就记一笔，出新片时自动改判。',
        noClusterFile: '这个剧本还没有动作意图聚类分析。先运行 analyze-intent-clusters.mjs 写入最新分析。',
        enqueue: '加入手工队列',
        enqueued: '已加入生成队列',
        merged: '队列里已有相同或相近的意图，已合并',
        enqueueAuto: '加入自动队列',
        autoQueued: '已加入自动队列：认领 → 写提示词 → 出片全自动跑，进度看生产状态列',
        selectAll: '全选',
        selectRow: '选择「{intent}」',
        batchAutoQueue: '批量加入自动队列（{n}）',
        batchProgress: '{done}/{total} 完成',
        batchAutoQueuedAllOk: '批量自动队列完成：{n} 条全部成功',
        batchAutoQueuedPartial: '批量自动队列完成：成功 {ok} 条，失败 {fail} 条',
        detailTitle: '聚类详情',
        back: '返回',
        notFound: '没找到这个聚类，当前分析可能已经更新。',
        representative: '代表意图',
        occurrenceDetail: '{n} 次，{v} 种写法',
        samples: '写法变体',
        samplesTruncated: '还有 {n} 条未收录进清单',
        emptyTitle: '没有匹配的聚类',
        emptyDescription: '可以清空或调整当前筛选条件。',
      },
    },
    assetLibrary: {
      title: '资产库',
      subtitle: '角色图、背景图、NPC图、道具图、出片提示词，按游戏隔离管理；也能浏览全部已生成的媒体文件。',
      create: '新建资产',
      deleted: '已删除',
      deleteConfirm: '确认删除资产「{name}」？',
      tabs: {
        talkingVideos: '无声说话视频',
        curated: '策展库',
        allMedia: '全部资产',
      },
      talkingVideos: {
        specReviewTitle: '角色状态与 H3 生成规格',
        specReviewDescription: '先审核每个角色的有限说话状态、选用条件、完整提示词、生成参数和参考图；审核通过后再生成并绑定无声视频。',
        noSpecs: '还没有可审核的说话状态规格',
        stateCount: '{count} 个状态',
        identityReference: '角色基础图',
        identityReferenceDescription: '该角色全部状态图共用的唯一身份、年龄和服装基准；点击可查看原始资产。',
        promptQuality: {
          draft: '待审核',
          approved: '已通过',
          rejected: '已驳回',
        },
        promptQualityLabel: '规格状态',
        allPromptQualities: '全部规格状态',
        availablePhases: '可用剧情阶段',
        videoReady: '已有成片',
        videoPending: '待生成',
        videoPreviewEmpty: '视频尚未生成',
        bindVideo: '绑定视频素材',
        reviewPrompt: '查看规格',
        approvePrompt: '通过',
        rejectPrompt: '驳回',
        promptReviewed: '提示词审核状态已更新',
        generatedTitle: '已生成并绑定的视频',
        generatedDescription: '这里管理已经生成的无声视频、起始画面和结束画面；运行时只会播放完整且处于使用中状态的三项绑定。',
        generatedVideoPreview: '生成视频预览',
        videoPendingHint: '这个状态还没有生成并绑定无声视频，通过规格后可在下方「绑定视频素材」或等待自动生成。',
        selectionLogic: '状态使用条件',
        composition: '构图与位置',
        facialPerformance: '神态与脸部细节',
        mouthMotion: '口型节奏',
        microAction: '状态动作',
        excludedEmotions: '禁止混入的情绪',
        stateFrame: '状态基准图',
        stateFrameAndPrompt: '状态基准图与生成提示词',
        openStateFrame: '查看状态基准图资产',
        h3Params: 'H3 生成参数',
        referenceImages: '场景与角色参考图',
        fullPrompt: '完整 H3 提示词',
        embeddingCall: '查看提示词向量计算调用',
        emptyTitle: '还没有配置无声说话视频',
        emptyDescription: '点击「新增配置」绑定角色、表情状态、无声视频及首尾画面。',
        create: '新增配置',
        createTitle: '新增无声说话视频',
        editTitle: '编辑无声说话视频',
        actor: '角色',
        actorType: '角色类型',
        allActors: '全部角色',
        pack: '游戏',
        allPacks: '全部游戏',
        scope: '游戏与表情',
        expression: '表情状态',
        expressionHint: '使用小写字母、数字和下划线；未配置精确状态时回落到 default。',
        video: '无声说话视频',
        startFrame: '起始画面',
        endFrame: '结束画面',
        frames: '首尾画面',
        videoAssetId: '视频资产编号',
        startFrameAssetId: '起始画面资产编号',
        endFrameAssetId: '结束画面资产编号',
        silentHint: '保存时会校验视频元数据，包含音轨的视频不能绑定。',
        silent: '无声',
        hasAudio: '包含声音',
        openAsset: '查看资产详情',
        searchPlaceholder: '搜索角色、角色编号或表情状态',
        status: '状态',
        allStatuses: '全部状态',
        published: '使用中',
        withdrawn: '已下线',
        sort: '排序字段',
        order: '排序方向',
        sortUpdated: '更新时间',
        sortActor: '角色名称',
        sortPack: '游戏名称',
        desc: '降序',
        asc: '升序',
        history: '变更记录',
        historyTitle: '无声说话视频变更记录',
        restore: '恢复',
        withdraw: '下线',
        withdrawConfirm: '确认下线「{name}」的 {expression} 无声说话视频？三项绑定会同时下线。',
        withdrawnNotice: '三项绑定已同时下线',
        saved: '三项绑定已保存',
        kind: {
          video: '视频',
          start_frame: '起始画面',
          end_frame: '结束画面',
          state_frame: '状态基准图',
        },
        action: {
          create: '创建',
          update: '更新',
          status_change: '状态变更',
        },
      },
      curated: {
        pack: '游戏',
      },
      allMedia: {
        pack: '归属游戏',
        allPacks: '全部游戏',
        global: '全局',
        preview: '预览',
        size: '大小',
        searchPlaceholder: '按标识搜索',
        open: '打开',
        id: 'ID',
        draftId: '草稿ID',
        mime: 'MIME',
        objectKey: '存储路径',
        publicUrl: '访问地址',
        hash: '内容哈希',
        metadata: '元数据',
        createdAt: '创建时间',
        updatedAt: '更新时间',
      },
      detail: {
        title: '资产详情',
        back: '返回',
        notFound: '没找到这条资产。',
        basicInfo: '基本信息',
        storageInfo: '存储信息',
      },
      filters: {
        allTypes: '全部类型',
        search: '搜索',
        searchPlaceholder: '按名称 / 标识 / 描述搜索',
        apply: '筛选',
      },
      type: {
        image: '图片',
        video: '视频',
        audio: '音频',
        prompt: '提示词',
      },
      table: {
        type: '类型',
        kind: '分类',
        subject: '角色',
        stateLabel: '状态',
        tag: '标识',
        name: '名称',
        description: '描述',
        content: '内容',
        updatedAt: '更新时间',
      },
      kind: {
        scene: '场景锚点图',
        character_identity: '角色默认形象',
        character_state: '角色状态变体',
        prop: '道具',
      },
      pager: {
        summary: '共 {total} 条 · 第 {page} / {pages} 页',
        prev: '上一页',
        next: '下一页',
        pageSize: '每页',
      },
      form: {
        createTitle: '新建资产',
        editTitle: '编辑资产',
        tagHint: '标识在同一个游戏内唯一，建好之后不能改，改标识请删了重建。',
        kindHint: '意图视频写提示词时靠这个字段分辨这条数据是干什么用的。',
        subjectHint: '如 npc、player，同一角色的默认形象和状态变体靠它绑在一起。',
        stateLabelHint: '这个状态叫什么（如"浴池中"），意图视频会把它列给 AI 看。',
        textContent: '提示词正文',
        file: '文件',
        fileReplaceHint: '不选则保留原文件，选了就替换成新的。',
        existingMediaAssetId: '已有素材编号（可选）',
        existingMediaAssetIdHint: '这条数据已经在「全部资产」里传过，直接填它的编号，不用重新上传一遍文件。填了这项就不用选文件。',
        saved: '已保存',
      },
      emptyTitle: '这个游戏还没有资产',
      emptyDescription: '点右上角「新建资产」加第一条。',
    },
    promptLibrary: {
      emptyTitle: '没有匹配的提示词',
      approve: '通过',
      reject: '拒绝',
      reviewed: '已更新审批状态',
      quality: { draft: '待审', approved: '已通过', rejected: '已拒绝' },
      filters: {
        allModalities: '全部模态',
        allQualities: '全部审批状态',
        packPlaceholder: '按 pack_id 筛选（留空看全部）',
      },
      table: {
        quality: '审批状态',
        modality: '模态',
        pack: '所属剧本',
        promptText: '提示词正文',
        source: '来源',
        createdAt: '创建时间',
        similarity: '相似度',
      },
      recall: {
        title: '检索召回测试',
        hint: '写新提示词前，先搜一下有没有相似的已通过提示词可以当 few-shot 参考。',
        placeholder: '输入意图/效果描述，找相似的已生产提示词',
        run: '搜索',
        noHitTitle: '没有找到相似的提示词',
      },
    },
    entityLibrary: {
      create: '新建实体',
      created: '已创建',
      emptyTitle: '还没有实体',
      type: { npc: 'NPC', player: '玩家角色', scene: '场景', prop: '道具', effect: '效果' },
      filters: {
        allTypes: '全部类型',
        searchPlaceholder: '按名称搜索',
      },
      table: {
        image: '图片',
        type: '类型',
        canonicalName: '名称',
        aliases: '别名',
        status: '状态',
        source: '来源',
      },
      form: {
        aliasesHint: '多个别名用逗号分隔',
      },
      detail: {
        factsTitle: '世界观硬事实（hard_facts）',
        factsHint: '不可被具体游戏覆盖的世界观级设定，自由 JSON——世界观圣经文档定下字段规范前先这么记。',
        factsInvalidJson: '不是合法的 JSON 对象',
        factsSaved: '已保存世界观设定',
        deepResearch: {
          run: '起 Deep Research 摄取',
          hint: 'NPC/玩家/场景/道具找参考图，效果类找 prompt 写法。自动入库可直接用，不合格的之后在资产列表里下线。',
          done: '已入库 {ingested} 条，跳过 {skipped} 条',
        },
        assets: {
          title: '挂载的资产',
          emptyTitle: '还没有挂任何资产',
          type: '资产类型',
          pack: '所属游戏',
          role: '角色标签',
          status: '状态',
          ref: '指向',
          canonical: '通用（不限游戏）',
          withdraw: '下线',
          withdrawn: '已下线',
          saved: '已保存',
          promptId: 'prompt_id',
          mediaAssetId: 'media_asset_id',
        },
        relationships: {
          title: '实体关系',
          emptyTitle: '还没有记录任何关系',
          direction: '方向',
          other: '对方',
          address: '称呼',
          notes: '备注',
          toEntityId: '对方 entity id',
          saved: '已保存',
        },
      },
    },
    analytics: {
      title: '运营总览', since: '开始日期', until: '结束日期', refresh: '刷新报表',
      metrics: {
        active_players: '活跃玩家', interactions: '总互动', say_turns: '对话次数', act_turns: '行动次数',
        credits_spent: '积分消耗', credits_granted: '积分获得', runs_started: '开局数', runs_completed: '完成关卡',
        seasons_started: '开季数', seasons_completed: '完成季', paying_players: '付费玩家', activePlayers: '活跃玩家',
      },
      daily: { title: '每日互动趋势', date: '日期' },
      drilldown: {
        title: '{metric}明细', summary: '共 {total} 位玩家，当前展示前 50 位', backToTrend: '返回趋势',
        player: '玩家', accountType: '账号类型', lastInteraction: '最近互动',
        accountTypes: { registered: '注册用户', guest: '游客' },
      },
      interactions: {
        title: '{player}的互动明细', summary: '共 {total} 次互动，当前展示最近 50 条', back: '返回玩家明细',
        time: '互动时间', story: '短剧 / 关卡', position: '剧情位置', mode: '类型', content: '玩家具体说了 / 做了什么',
        season: '第 {number} 季', episode: '第 {number} 集', turn: '第 {number} 回合', modes: { say: '说话', act: '行动' },
      },
    },
    contentAnalytics: {
      title: '内容互动报表', series: '剧集', scenario: '关卡', episode: '集数', standalone: '独立剧本',
      activePlayers: '互动玩家', started: '开局', completed: '完成关卡', completionRate: '完成率',
      interactions: '总互动', dialogues: '对话', actions: '行动',
    },
    ga4Behavior: {
      title: 'GA4 用户行为', description: '来源、国家/地区、页面、设备、视频、点击热区与输入方式的聚合数据。',
      setupTitle: 'GA4 Data API 尚未配置', setupBody: '在 visual-game-server 配置数字 Property ID 与 Google 服务账号凭据，并授予该服务账号 GA4 Property 的查看者权限。',
      flowHint: '来源基于 page_referrer；它适合观察页面间跳转，不等同于 GA4 探索中的完整用户路径。',
      sceneHint: '只展示没有命中交互目标的场景点击；grid_x / grid_y 是画面十等分坐标，可定位用户反复点击的门窗区域。',
      videoHint: '观看进度在视频播放到 25%、50%、75% 时各记录一次；同一视频被多次观看时会累计。',
      videoOpen: '查看视频', videoUnavailable: '视频已不可用',
      videoStartNone: '未记录开始播放', videoStartCount: '开始播放 {count} 次',
      videoProgressNone: '未达到观看节点', videoProgressCount: '{count} 次达到观看节点',
      videoCompletionNone: '未记录完整播完', videoCompletionCount: '完整播完 {count} 次', videoUserCount: '{count} 位用户',
      summary: { unique_visitors: 'UV（独立访客）', active_users: '活跃用户', page_views: 'PV（页面浏览量）', sessions: '会话', video_viewers: '视频观众', video_starts: '视频开始', video_completions: '视频播完', ui_clicks: '按钮点击', scene_clicks: '画面点击', typed_inputs: '自由输入', selected_inputs: '点选输入' },
      sections: { traffic: 'UV / PV 趋势', sources: '媒体来源', locations: '国家/地区', pages: '看了哪些页面', flows: '页面跳转', devices: '设备与浏览器', videos: '视频观看', clicks: '点击了什么', sceneMisses: '场景误点热区', inputs: '输入还是点选' },
      sourceNotes: { x_referral: '用户通过 X（原 Twitter）中的链接访问', facebook_referral: '用户通过 Facebook 中的链接访问', instagram_referral: '用户通过 Instagram 中的链接访问', youtube_referral: '用户通过 YouTube 中的链接访问', tiktok_referral: '用户通过 TikTok 中的链接访问', direct: 'GA4 未获得引荐来源；可能是直接输入网址、书签访问，或跳转过程中来源信息丢失', unassigned: 'GA4 无法为这些会话确定默认渠道，常见于来源信息缺失、异常或尚未完成归因', organic_social: '来自未付费的社交媒体链接；具体平台请查看来源 / 媒介', organic_search: '来自 Google 等搜索引擎的自然搜索结果', referral: '来自其他网站中的外部链接', paid_social: '来自社交媒体广告', paid_search: '来自搜索广告', other: 'GA4 默认渠道分类；具体来源请查看来源 / 媒介' },
      clickNote: '用户在“{area}”点击了“{action}”',
      clickLabels: {
        elements: { continue_game: '继续游戏', start_game: '开始游戏', view_journey: '查看故事线', watch_drama: '观看短剧', select_character: '选择角色', continue_ending: '继续结局', enter_next_episode: '进入下一集', view_ending_record: '查看结局记录', select_video_episode: '选择视频剧集', share_video: '分享视频', toggle_video_favorite: '收藏或取消收藏视频', toggle_video_like: '点赞或取消点赞视频', video_to_game: '从视频进入游戏' },
        surfaces: { landing_hero: '首页顶部主视觉区', landing_story: '首页故事轮播区', character_select: '角色选择页', ending_book: '结局页', game_hud: '游戏操作区', video_center: '视频中心' },
      },
      inputLabels: { methods: { typed: '自由输入', voice: '语音输入', suggested_choice: '点击推荐选项', map_move: '地图移动' }, modes: { say: '说话', act: '动作' } },
      videoLabels: { placements: { video_center: '视频中心' } },
      columns: { date: '日期 / 时间', unique_visitors: 'UV（独立访客）', page_views: 'PV（页面浏览量）', channel: '默认渠道', source_medium: '来源 / 媒介', campaign: '广告活动', note: '备注', country: '国家', region: '地区', path: '页面路径', title: '页面标题', views: '浏览量', users: '用户', from: '来源页面', to: '目标页面', category: '设备', operating_system: '操作系统', browser: '浏览器', sessions: '会话', video_id: '视频 ID', video_title: '视频标题', video_url: '视频链接', placement: '观看位置', starts: '播放情况', progress_events: '观看进度', completions: '播完情况', element_id: '按钮 ID', surface: '按钮位置', action: '点击内容', area: '所在区域', clicks: '点击', scene_id: '场景 ID', grid_x: '网格 X', grid_y: '网格 Y', pointer_type: '指针', input_method: '输入方式', mode: '行为模式', submissions: '提交' },
    },
    users: {
      title: 'C 端用户',
      provision: {
        trigger: '开通账号', title: '管理员开通账号', email: '邮箱', password: '初始密码', passwordConfirmation: '确认初始密码', locale: '账号语言', initialCredits: '初始积分', reason: '开通原因', confirm: '确认开通', success: '账号已开通',
        notice: '此操作仅限管理员：邮箱将被标记为已验证，密码经正式哈希后保存，初始积分与操作原因会记入审计和积分流水。',
      },
      metrics: {
        total: '用户总数',
        registered: '注册用户',
        guests: '游客用户',
        players: '有游玩记录',
        payers: '有支付记录',
      },
      filters: {
        q: '搜索用户',
        qPlaceholder: '邮箱、显示名或用户 ID',
        type: '账号类型',
        subscription: '订阅状态',
        since: '统计开始日期',
        until: '统计结束日期',
        all: '全部',
        search: '搜索',
      },
      type: { registered: '注册用户', guest: '游客' },
      subscriptionStatus: {
        none: '未订阅',
        active: '生效中',
        expired: '已过期',
        canceled: '已取消',
      },
      table: {
        identity: '用户标识',
        type: '类型',
        displayName: '显示名',
        locale: '语言',
        credits: '点数余额',
        creditsSpent: '期间消耗',
        creditsGranted: '期间获得',
        subscription: '订阅',
        runs: '游戏局数',
        turns: '累计回合',
        interactions: '期间互动',
        sayTurns: '期间对话',
        actTurns: '期间行动',
        completedRuns: '完成关卡',
        completedSeasons: '完成季',
        endings: '结局数',
        orders: '订单数',
        lastActive: '最近活跃',
        createdAt: '创建时间',
      },
      pagination: {
        summary: '共 {total} 人 · 第 {page}/{pages} 页',
        pageSize: '每页条数',
        previous: '上一页',
        next: '下一页',
      },
      empty: {
        title: '没有找到用户',
        description: '可以清空或调整当前筛选条件。',
      },
      detail: {
        title: '用户详情',
        back: '返回用户列表',
        refresh: '刷新',
        profile: '账号资料',
        overview: '订阅与游玩概览',
        fields: {
          id: '用户 ID',
          displayName: '显示名',
          nickname: '昵称',
          avatar: '头像 URL',
          accountLocale: '账号语言',
          profileLocale: '资料语言',
          emailVerified: '邮箱验证时间',
          createdAt: '创建时间',
        },
        metrics: {
          credits: '点数余额',
          runs: '游戏局数',
          activeRuns: '进行中局数',
          completedRuns: '已完成局数',
          turns: '回合数',
          sayTurns: '对话次数',
          actTurns: '行动次数',
          creditsSpent: '累计消耗点数',
          creditsGranted: '累计获得点数',
          completedSeasons: '完成季数',
          scenarios: '游玩剧本数',
          progress: '进度记录数',
          endings: '解锁结局数',
          saves: '存档数',
          lastActive: '最近活跃',
        },
        subscription: {
          status: '订阅状态',
          level: '订阅等级',
          expiresAt: '到期时间',
          provider: '服务商',
          source: '来源',
        },
        guestDevices: {
          title: '游客设备',
          status: '状态',
          lastSeen: '最近访问',
          mergedUser: '合并到用户',
          statuses: { active: '使用中', merged: '已合并' },
        },
        behavior: {
          title: '用户行为轨迹（最近 200 条）', empty: '暂无行为记录。', sessions: '会话数', events: '事件数', engagement: '有效停留',
          time: '时间', event: '用户行为', page: '所在页面', duration: '有效停留', details: '行为说明',
          durationValue: '{minutes} 分 {seconds} 秒',
          viewMode: '轨迹展示方式', pageVisits: '按页面访问', rawEvents: '原始事件', operations: '次操作',
          grouping: { exact: '准确分组', inferred: '历史推断' },
          help: '第一行是运营可读的行为名称，第二行灰色小字是供技术排查使用的事件标识。有效停留仅统计页面处于前台的时间。',
          unknown: '未知',
          unknownVideo: '未知视频', openVideo: '查看视频',
          unknownControl: '页面功能', unknownArea: '当前页面',
          unknownDevice: '未知设备', unknownLocation: '未知地区', unknownSource: '未知来源',
          dayDevice: '设备：{value}', dayLocation: '地区：{value}', daySource: '来源：{value}',
          clickEventName: '点击“{target}”', resultEventName: '“{action}”操作结果',
          oauthControl: '使用 {method} 登录',
          noAdditionalDetails: '无补充信息',
          eventNames: {
            page_view: '浏览页面', page_engagement: '在页面停留', game_start: '开始游戏', turn_submit: '提交剧情操作',
            ending_reached: '达成剧情结局', vg_video_start: '开始播放视频', vg_video_progress: '观看视频',
            vg_video_complete: '看完视频', vg_video_error: '视频播放失败', ui_click: '点击页面功能',
            action_result: '操作结果',
            scene_click: '点击场景互动', billing_paypoint_gameplay: '触发游戏付费提示',
            billing_paypoint_ending_video: '触发结局视频付费提示', billing_paypoint_story_video: '触发剧情视频付费提示',
            login: '登录网站', sign_up: '注册账号',
            content_click: '点击首页内容',
          },
          pageNames: {
            home: '首页', stories: '剧情列表', dramas: '短剧列表', search: '搜索页', login: '登录页', game: '游戏页面',
            storyTree: '故事线页面', storyDetail: '剧情详情页', playerProfile: '玩家主页', account: '个人中心',
            accountEdit: '编辑资料', accountSettings: '账号设置', myGames: '我的游戏', myVideos: '我的视频',
            myFavorites: '我的收藏', videoGeneration: '视频生成页', create: '创作页', billing: '订阅付费页',
            credit: '点数页面', waitlist: '候补名单页',
          },
          descriptions: {
            pageView: '进入“{page}”', pageEngagement: '在“{page}”有效停留 {duration}',
            gameStart: '开始体验剧情（剧情 ID：{id}）', gameStartGeneric: '开始体验剧情',
            gameStartNamed: '开始体验剧情《{title}》（剧情 ID：{id}）',
            turnSubmit: '通过“{method}”提交了一次剧情操作', turnSubmitNamed: '在《{title}》中通过“{method}”提交了一次剧情操作',
            endingReached: '达成结局（结局 ID：{id}）', endingReachedNamed: '在《{title}》中达成结局（结局 ID：{id}）',
            endingReachedGeneric: '完成剧情并达成结局', videoStart: '开始播放视频《{video}》（ID：{id}）', videoProgress: '视频《{video}》（ID：{id}）已观看至 {percent}%',
            videoComplete: '已看完视频《{video}》（ID：{id}）',
            videoError: '视频《{video}》（ID：{id}）播放出错（错误码：{code}）', uiClick: '在“{surface}”点击了“{target}”', storyLevelClick: '从“故事线”进入游戏章节《{title}》（章节 ID：{id}）',
            actionResult: '“{action}”操作结果：{result}',
            sceneClick: '点击场景，结果：{result}', auth: '使用“{method}”方式完成操作',
            contentClick: '从“{surface}”点击{type}《{title}》（第 {position} 位），前往 {destination}',
          },
          inputMethods: { text: '文字输入', voice: '语音输入', choice: '选项', unknown: '未知方式' },
          authMethods: { email: '邮箱', google: 'Google', apple: 'Apple', x: 'X', discord: 'Discord', facebook: 'Facebook', tiktok: 'TikTok', guest: '游客', password: '邮箱密码' },
          interactionResults: { hit: '触发互动', miss: '未触发互动' },
          contentTypes: { game: '游戏', drama: '短剧' },
          contentSurfaces: { homepage_carousel: '首页轮播', homepage_game: '首页游戏板块', homepage_drama: '首页短剧板块' },
          actionResults: { succeeded: '成功', failed: '失败', canceled: '取消' },
          deviceTypes: { desktop: '电脑', mobile: '手机', tablet: '平板' },
          trafficSources: { direct: '直接访问', unknown: '未知来源' },
          trafficMediums: { none: '无', referral: '外部网站', campaign: '推广活动', organic: '自然搜索', cpc: '付费广告', email: '邮件' },
          controlLabels: {
            start_game: '开始游戏', select_character: '选择角色', retry_load: '重新加载', back: '返回', back_home: '返回首页', back_account: '返回个人中心', back_to_game: '返回游戏', brand_home: '返回 VOKO 首页',
            nav_logo: '网站 Logo', nav_search: '搜索', nav_login: '登录或注册', nav_account: '个人中心', nav_signup_reward: '注册奖励', logout: '退出登录',
            auth_prompt_close: '关闭登录弹窗', auth_method_back: '返回登录方式', auth_email: '邮箱登录', auth_more_options: '更多登录方式', send_login_code: '发送登录验证码', email_code_login: '使用验证码登录',
            story_card: '剧情卡片', game_card: '游戏卡片', start_checkout: '前往支付', select_credit_pack: '选择点数包', open_billing: '购买点数', open_credit_history: '查看点数记录', credit_tab: '切换点数栏目', credit_history_filter: '筛选点数记录',
            share_story: '分享剧情', share_video: '分享视频', video_share: '分享视频', toggle_story_like: '点赞剧情', toggle_story_favorite: '收藏剧情', toggle_video_like: '点赞视频', toggle_video_favorite: '收藏视频', video_like: '点赞视频', video_favorite: '收藏视频',
            view_journey: '查看故事线', view_player: '查看作者', watch_drama: '观看短剧', video_to_game: '进入游戏', select_video_episode: '选择视频', open_video: '打开视频', open_video_title: '打开视频', owned_video_card: '打开我的视频', favorite_game_card: '打开收藏游戏',
            video_playback_toggle: '播放或暂停视频', video_sound_toggle: '打开或关闭声音', video_summary_toggle: '展开或收起简介', play_ending_video: '播放结局视频', open_generated_video: '查看生成视频', download_replay: '下载回放',
            clear_filters: '清空筛选', clear_search: '清空搜索', clear_search_history: '清空搜索记录', search_back_home: '返回首页', search_history_item: '历史搜索', popular_search: '热门搜索', search_result: '搜索结果', search_type: '切换搜索类型',
            story_filter: '筛选剧情', story_layout: '切换剧情布局', story_drama_sort: '短剧排序', story_tree_sort: '故事线排序', player_sort: '视频排序', generation_filter: '筛选生成任务', video_library_tab: '切换视频分类', account_tab: '切换个人中心栏目', notes_tab: '切换笔记栏目', notes_entry: '查看笔记条目',
            player_synopsis_toggle: '展开或收起简介', load_more: '加载更多', season_toggle: '展开或收起季', story_level: '进入游戏章节', open_story_log: '查看游玩记录', close_story_log: '关闭游玩记录', open_story_picker: '切换故事', close_story_picker: '关闭故事选择', select_story: '选择故事', story_tree_tools_toggle: '展开或收起故事线工具', story_tree_newer: '查看较新剧情', story_tree_older: '查看较早剧情', dismiss_current_season_tip: '关闭当前季提示', story_summary_toggle: '展开或收起故事摘要', ending_summary_toggle: '展开或收起结局简介', close_story_video: '关闭结局视频', cancel_story_fork: '取消创建剧情分支', cancel_delete_branch: '取消删除剧情分支', select_run: '查看对局', open_notes: '查看对局笔记',
            view_ending_record: '查看结局记录', replay_episode: '重新体验本集', continue_ending: '继续结局内容', enter_next_episode: '进入下一集', confirm_story_fork: '确认创建剧情分支', confirm_delete_branch: '确认删除剧情分支',
            game_tools_toggle: '展开或收起游戏工具', game_tool_debug: '切换调试视图', game_tool_status: '查看任务状态', game_tool_map: '打开地图', game_tool_notes: '打开笔记', game_tool_story_log: '打开游玩记录', game_tool_settings: '打开游戏设置',
            close_game_panel: '关闭游戏面板', cancel_game_action: '取消游戏操作', confirm_game_action: '确认游戏操作', map_location_select: '选择地图位置', map_move: '移动至地图位置',
            voice_input_text_mode: '切换文字输入', voice_input_start: '开始语音输入', save_game: '保存游戏', load_game: '读取存档', delete_save: '删除存档', overwrite_save: '覆盖存档', cancel_save_action: '取消存档操作',
            game_setting_change: '修改游戏设置', save_and_exit_game: '保存并退出游戏', exit_game_without_saving: '不保存退出游戏', skip_media: '跳过媒体', skip_onboarding: '跳过新手引导', onboarding_step: '下一步引导', complete_onboarding: '完成新手引导',
            composer_mode: '切换回合模式', input_mode_toggle: '切换输入方式', submit_turn: '提交回合', suggested_choice: '选择建议选项', suggested_choice_summary_toggle: '展开或收起建议选项',
            open_language_picker: '打开语言选择', select_language: '选择语言', close_language_picker: '关闭语言选择', open_notifications: '打开通知', close_notifications: '关闭通知', notification_item: '查看通知',
            play_full_replay: '播放完整回放', request_replay_export: '生成完整回放', replay_playback_toggle: '播放或暂停回放', replay_turn: '回放本回合', download_replay_turn: '下载本回合', play_replay_segment: '播放回放分段', download_replay_segment: '下载回放分段',
            claim_daily_reward: '领取每日奖励', billing_login: '登录后购买点数', refresh_billing: '刷新账单', open_checkout: '打开结账页', billing_tab: '切换账单栏目',
            generate_story_video: '生成故事视频', retry_story_video: '重试生成故事视频', generate_turn_video: '生成回合视频', retry_turn_video: '重试生成回合视频', open_turn_video: '查看回合视频', confirm_video_generation: '确认生成视频', confirm_turn_video_generation: '确认生成回合视频', cancel_video_generation: '取消生成视频', close_video_generation: '关闭视频生成提示', open_video_generation_progress: '查看视频生成进度', open_video_generation_billing: '购买视频生成点数',
            game_account_toggle: '展开或收起游戏账户', logout_all: '退出所有设备', game_account_tab: '切换账户功能', password_visibility_toggle: '显示或隐藏密码', account_login: '登录账户', account_register: '注册账户', account_reset_password: '重置密码', forgot_password: '忘记密码', continue_as_guest: '继续游客体验',
            edit_profile: '编辑资料', save_profile: '保存资料', send_verification_code: '发送验证码', account_games: '我的游戏', account_videos: '我的视频', account_favorites: '我的收藏', account_generation: '视频生成记录',
            create_project: '创建项目', upload_asset: '上传素材', submit_creation: '提交创作', delete_project: '删除项目', save_auto_reload: '保存自动充值', disable_auto_reload: '关闭自动充值',
            submit_waitlist: '提交候补申请', retry_waitlist: '修改申请信息', open_invite: '使用邀请码',
            oauth_login: '第三方账号登录', load_search: '加载搜索结果', submit_search: '搜索', load_story_tree: '加载故事线', load_standalone_notes: '加载对局笔记', load_credit_history: '加载点数记录', load_video_generations: '加载视频生成记录', fork_story_turn: '创建剧情分支', delete_story_branch: '删除剧情分支',
          },
          surfaceLabels: {
            character_select: '角色选择区', game_hud: '游戏操作区', game_toolbar: '游戏工具栏', game_overlay: '游戏面板', game_confirm_dialog: '游戏确认弹窗', game_map: '游戏地图', game_composer: '游戏回合输入', game_suggestions: '游戏建议选项', game_saves: '游戏存档', game_settings: '游戏设置', game_media_overlay: '游戏媒体遮罩', game_onboarding: '游戏新手引导', game_account: '游戏账户', site_header: '顶部导航', site_header_mobile: '移动端顶部导航', mobile_navigation: '移动端导航', auth_dialog: '登录弹窗', auth_scrim: '登录弹窗外部', language_switcher: '语言选择', notifications: '通知中心', story_log: '游玩记录', points: '点数奖励', points_store: '点数商店', insufficient_balance: '点数不足提示', billing: '账单与结账', video_generation: '视频生成',
            homepage_carousel: '首页轮播', homepage_game: '首页游戏区', stories_header: '剧情页顶部', stories_filters: '剧情筛选区', stories_list: '剧情列表', story_detail: '剧情详情', story_related_dramas: '相关短剧', story_tree: '故事线',
            dramas_list: '短剧列表', video_center: '玩家影像馆', player_stories: '玩家作品区', owned_video_player: '我的视频播放页', video_library: '视频列表', favorites: '收藏列表', player_page: '玩家主页',
            search_header: '搜索页顶部', search_history: '搜索记录', search_popular: '热门搜索', search_results: '搜索结果', run_history: '对局历史', standalone_notes: '对局笔记', ending_book: '结局记录', ending_book_mobile: '移动端结局记录',
            account_mobile: '移动端个人中心', account_header: '个人中心顶部', account_sidebar: '个人中心侧栏', account_edit: '编辑资料页', account_settings: '账号设置页', my_games: '我的游戏', my_games_recent: '最近游玩', my_games_popular: '热门游戏',
            credit_page: '点数页面', credit_balance: '点数余额区', credit_products: '点数商品区', credit_history: '点数记录', credit_auto_reload: '自动充值设置', billing_auto_reload: '自动充值设置', creator_projects: '创作项目', creator_projects_mobile: '移动端创作项目', creator_desktop: '创作表单', creator_mobile: '移动端创作表单', video_generation: '视频生成页', waitlist: '候补申请页',
          },
        },
        ledger: {
          title: '点数流水（最近 50 条）',
          empty: '没有点数流水。',
          time: '时间',
          id: '流水 ID',
          type: '类型',
          amount: '变动',
          balance: '变动后余额',
          reason: '原因',
          reference: '关联记录',
          types: { grant: '增加', deduct: '扣减' },
        },
        audit: {
          title: '后台操作记录（最近 50 条）',
          empty: '没有后台操作记录。',
          time: '时间',
          action: '操作',
          operator: '操作人',
          reason: '原因',
          actions: {
            account_provisioned: '管理员开通账号',
            profile_updated: '修改资料',
            credits_granted: '增加点数',
            credits_deducted: '扣减点数',
            subscription_updated: '修改订阅',
          },
        },
        orders: {
          title: '订单（最近 30 条）',
          empty: '没有订单。',
          time: '创建时间',
          id: '订单 ID',
          product: '商品',
          mode: '模式',
          provider: '支付渠道',
          status: '状态',
          amount: '金额',
          refund: '退款金额',
          modes: { payment: '单次支付', subscription: '订阅' },
          statuses: {
            pending: '待支付',
            paid: '已支付',
            refunded: '已退款',
            disputed: '争议中',
          },
        },
        runs: {
          title: '最近游玩（最近 20 局）',
          empty: '没有游玩记录。',
          time: '最近更新',
          id: 'Run ID',
          scenario: '剧本',
          status: '状态',
          turns: '回合数',
          phase: '阶段',
          location: '当前位置',
          viewInteractions: '查看互动',
          interactions: {
            title: '{scenario} · 互动记录',
            summary: '本局共 {total} 次互动，按时间倒序展示最近 100 条。',
            empty: '这一局没有已完成的互动。',
            turn: '回合',
          },
          statuses: { active: '进行中', completed: '已完成' },
        },
      },
      actions: {
        reason: '操作原因',
        profile: {
          trigger: '编辑资料',
          title: '编辑用户资料',
          nickname: '昵称',
          avatar: '头像 URL',
          locale: '语言',
          success: '用户资料已更新。',
        },
        credits: {
          trigger: '调整点数',
          title: '调整用户点数',
          type: '调整方式',
          grant: '增加',
          deduct: '扣减',
          amount: '点数',
          notice: '当前余额：{balance}。扣减时余额不足会整笔失败，不会产生流水。',
          confirm: '确认调整',
          success: '点数已调整并写入流水。',
        },
        subscription: {
          trigger: '修改订阅',
          title: '修改用户订阅',
          level: '订阅等级',
          status: '订阅状态',
          expiresAt: '到期时间',
          success: '订阅状态已更新。',
          rules: {
            none: '未订阅必须使用 free 等级且不填写到期时间。',
            active: '生效中必须使用非 free 等级；到期时间留空表示长期有效。',
            expired: '已过期必须使用非 free 等级，并填写不晚于当前时间的到期时间。',
            canceled: '已取消必须使用非 free 等级；该操作不会修改或伪造支付订单。',
          },
        },
      },
    },
    waitlist: {
      title: '早期访问候补名单',
      pagination: {
        previous: '上一页',
        next: '下一页',
      },
      metrics: {
        total: '总数',
        joined: '已加入',
        invitePending: '邀请中',
        invited: '已邀请',
        registered: '已注册',
        rejected: '已拒绝',
        failedDeliveries: '投递失败',
      },
      filters: {
        q: '搜索邮箱或名称',
        search: '查询',
        status: '状态',
        source: '来源',
        useCase: '用途',
        inviteState: '邀请状态',
        createdFrom: '创建起始',
        createdTo: '创建结束',
        all: '全部',
      },
      table: {
        email: '邮箱',
        displayName: '名称',
        status: '状态',
        inviteState: '邀请',
        source: '来源',
        useCase: '用途',
        createdAt: '创建时间',
        updatedAt: '更新时间',
        lastEvent: '最近事件',
      },
      detail: {
        profile: '资料',
        consent: '同意记录',
        status: '状态',
        delivery: '投递',
        timeline: '时间线',
        notes: '备注',
        actions: '操作',
        currentNote: '当前备注',
        invariantError: '缺少营销同意证据，邀请操作已阻止。',
      },
      fields: {
        displayName: '显示名',
        locale: '语言',
        source: '来源',
        useCase: '用途',
        note: '备注',
        consentAcceptedAt: '营销同意时间',
        consentRevokedAt: '撤销同意时间',
        expiresAt: '过期时间',
        registeredUserId: '注册用户 id',
        registeredAt: '注册时间',
        rejectedReason: '拒绝原因',
        provider: '服务商',
        messageId: '消息 id',
        sentAt: '发送时间',
        failedAt: '失败时间',
        errorMessage: '错误信息',
      },
      status: {
        joined: '已加入',
        invite_pending: '邀请中',
        invited: '已邀请',
        registered: '已注册',
        rejected: '已拒绝',
      },
      source: {
        landing_hero: '首页首屏',
        landing_footer: '首页底部',
        pricing: '定价页',
        manual_admin: '后台手动添加',
      },
      invite: {
        none: '待批准',
        pending: '投递中',
        sent: '已发送',
        failed: '失败',
        expired: '已过期',
        claimed: '已领取',
        closed: '已关闭',
      },
      modal: {
        manualTitle: '创建手动候补者',
        inviteTitle: '邀请候补者',
        resendTitle: '重发邀请',
        noteTitle: '新增备注',
        rejectTitle: '拒绝候补者',
        exportTitle: '导出候补名单',
        operatorNote: '运营备注',
        rejectReason: '拒绝原因',
        exportSummary: '导出会使用当前筛选条件。',
      },
      toast: {
        loaded: '候补名单已加载。',
        saved: '操作已完成。',
        exported: 'CSV 已导出。',
        failed: '操作失败。',
      },
    },
  },
}

zh.visualGameAdmin.pageFunnel.viewUsers = '查看用户'
zh.visualGameAdmin.pageFunnel.peopleUnit = '人'
zh.visualGameAdmin.pageFunnel.timesUnit = '次'

zh.visualGameAdmin.pageFunnel.userFilter_all = '漏斗筛选：注册或登录用户'

zh.visualGameAdmin.pageFunnel.userFilter_sign_up = '漏斗筛选：所选时间注册的用户'

zh.visualGameAdmin.pageFunnel.userFilter_login = '漏斗筛选：所选时间登录的用户'

zh.visualGameAdmin.usageActivity = {
  "title": "网站使用 · 行为明细",
  "button": "查看明细",
  "all": "全部行为",
  "search": "搜索用户、游戏或记录 ID",
  "user": "用户",
  "game": "游戏",
  "kind": "行为类型",
  "status": "状态",
  "time": "发生时间",
  "detail": "查看记录",
  "empty": "没有符合当前条件的记录",
  "loading": "正在加载…",
  "error": "加载失败",
  "note": "输入明细来自项目埋点，可能与 GA4 数字存在差异。输入原文和游戏局未记录时不作推断。",
  "limit": "展示最新 1000 条，可缩短时间范围查看其他记录。",
  "text_input": "文字输入",
  "voice_input": "语音输入",
  "slice_video": "视频生成（切片）",
  "global_video": "视频生成（全局）",
  "free_game": "游戏生成（Free）"
}

Object.assign(zh.visualGameAdmin.usageActivity, {
  "status_queued": "排队中",
  "status_running": "生成中",
  "status_ready": "已完成",
  "status_failed": "失败",
  "status_submitting": "提交中",
  "status_submitted": "已提交",
  "status_ok": "成功",
  "status_error": "失败",
  "status_generating": "生成中",
  "status_generation_failed": "生成失败",
  "status_pending_review": "待审核",
  "status_review_rejected": "审核驳回",
  "status_published": "已发布",
  "status_archived": "已归档"
})

zh.visualGameAdmin.usageActivity.records = '条记录'
